// ══════════════════════════════════════════════════════════════════════════════
//  src/components/admin/puertaDelCentroDeMando.js
//  QUIÉN PUEDE ENTRAR AL CENTRO DE MANDO — ESCRITO UNA SOLA VEZ
//
//  Rob, 24-09-2026: «si entro como administrador no tengo un botón de ir al
//  command center… manejando todas las pruebas de seguridad para que sea solo
//  mi cuenta de admin».
//
//  ── POR QUÉ ESTO ES UN FICHERO Y NO UN `if` EN CADA SITIO ───────────────────
//  Hasta hoy el correo autorizado estaba escrito a mano dentro de
//  `SuperAdminRoute.jsx`, en un solo sitio, y eso funcionaba porque no había
//  ningún otro sitio. En cuanto aparece un botón que decide si enseñar la
//  puerta, hay DOS sitios que tienen que decir lo mismo — y dos condiciones
//  copiadas se separan el día que una de las dos cambia.
//
//  La forma en que se separan siempre es la misma y es la peor: el botón se
//  queda más permisivo que la puerta. Alguien ve una entrada, la pulsa, y la
//  pantalla lo devuelve a su dashboard sin explicar nada. Parece una app rota.
//
//  ── ESTO NO ES LA SEGURIDAD ─────────────────────────────────────────────────
//  El `user` de `localStorage` se edita en dos clics desde las herramientas del
//  navegador: cualquiera puede ponerse el correo de Rob y ver el botón. Lo que
//  de verdad protege el CRM está en el servidor —todas las rutas
//  `/api/admin/*` piden `get_admin_user`, y contestan 403 a quien no lo sea—,
//  y ese 403 no se puede falsificar desde el navegador. Un panel lleno de
//  tablas vacías y errores 403 no es una filtración: es una pantalla inútil.
//
//  Esto sólo evita enseñarle una puerta a quien no la puede abrir, que es la
//  misma regla que ya sigue el enlace del profesor en la cabecera.
// ══════════════════════════════════════════════════════════════════════════════

/** La única cuenta que abre el centro de mando. */
export const CORREO_DEL_CENTRO_DE_MANDO = 'arq.robertoriv@gmail.com';

/** La dirección de la puerta, para no escribirla suelta en cada enlace. */
export const RUTA_DEL_CENTRO_DE_MANDO = '/command-center';

/**
 * ¿Este usuario puede entrar?
 *
 * Acepta el objeto ya desempaquetado. La comparación normaliza mayúsculas y
 * espacios porque un correo escrito con una mayúscula de más sigue siendo el
 * mismo correo, y dejar eso fuera crea el fallo más desconcertante posible:
 * la cuenta correcta, rechazada.
 */
export function puedeEntrarAlCentroDeMando(usuario) {
    const correo = String(usuario?.email ?? '').trim().toLowerCase();
    return correo !== '' && correo === CORREO_DEL_CENTRO_DE_MANDO;
}

/**
 * Lo mismo, leyendo del navegador. Lo usan la cabecera y la guardia de la
 * ruta, que es de donde salen los dos sitios que tenían que coincidir.
 *
 * Devuelve `false` ante cualquier problema —sin sesión, JSON roto,
 * almacenamiento bloqueado en una ventana privada—: ante la duda, no se enseña
 * la puerta.
 */
export function elDeLaSesionPuedeEntrar() {
    try {
        if (!localStorage.getItem('token')) return false;
        const crudo = localStorage.getItem('user');
        if (!crudo) return false;
        return puedeEntrarAlCentroDeMando(JSON.parse(crudo));
    } catch {
        return false;
    }
}
